import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipCode: '',
    message: '',
    consent: false
  });

  const [status, setStatus] = useState({
    message: '',
    isError: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.message) {
      setStatus({
        message: 'Please fill in all required fields',
        isError: true
      });
      return;
    }

    try {
      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone: `Phone No: ${formData.phone}`,
        zip_code: `Zip Code: ${formData.zipCode}`,
        message: `Message: ${formData.message}`,
        consent: `Consent: ${formData.consent ? 'Client has consented for replies' : 'Did not Consent'}`
      };

      // Replace these with your actual EmailJS credentials
      await emailjs.send(
        'service_e24swfk',
        'template_s1ywwye',
        templateParams,
        'iO1sUlQqrICtJtYJd'
      );

      setStatus({
        message: 'Thank you for your message. We will get back to you soon!',
        isError: false
      });
      
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        message: '',
        consent: true
      });

    } catch (error) {
      setStatus({
        message: 'There was an error sending your message. Please try again.',
        isError: true
      });
    }
  };

  return (
    <div className='contact-page-container'>
      <div className='contact-header-container'>
        <div className='contact-header-section'>
          <h3>AllTime Home Care</h3>
          <h1>Contact Us</h1>
          <h2>Want to find answers to your questions?</h2>
          <p>
            We're here to help you with any questions or concerns you may have. Please feel free to reach out to us using the contact information below or by filling out the contact form. Our dedicated team is ready to assist you and provide the support you need.
          </p>
        </div>
        <img src="./images/contact.jpeg" className='contact-image' alt="Services" />
      </div>

      <form onSubmit={handleSubmit}>
        <div className='input-section'>
          <p>*First Name</p>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className='input-section'>
          <p>*Last Name</p>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        <div className='input-section'>
          <p>*Email Address</p>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className='input-section'>
          <p>Phone Number</p>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <div className='input-section'>
          <p>Zip Code</p>
          <input
            type="text"
            name="zipCode"
            value={formData.zipCode}
            onChange={handleChange}
          />
        </div>
        <div className='input-section'>
          <p>*Message</p>
          <textarea
            rows="6"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        <div className='checkbox-section'>
          <input
            type='checkbox'
            name="consent"
            checked={formData.consent}
            onChange={handleChange}
          />
          <p>By checking this box and submitting, you consent to receive informational and marketing SMS text messages from AllTime Home Care related to non-medical home care services including personal, companion, homemaker, respite care and transportation for our clients. Message & data rates may apply. Messaging frequency may vary. You can reply STOP to opt-out of further messaging.</p>
        </div>

        {status.message &&(
          <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
            {status.message}
          </div>
        )}

        <button type="submit" className='submit-button'>
          Submit
        </button>
      </form>
    </div>
  );
}

export default Contact;